import { axiosService } from "@/services/AxiosService";

/**
 * @typedef {Object} HorseExam
 * @property {number} id - ID del record dell'esame
 * @property {number} horse_id - ID del cavallo associato
 * @property {number} exam_id - ID dell'esame associato
 * @property {Date} date - Data dell'esame
 * @property {Date} validity_date - Data di validità dell'esame
 * @property {string} created - Data di creazione del record
 * @property {string} modified - Data di modifica del record
 * @property {string} diagnosis - Diagnosi emessa durante l'esame
 * @property {string} note - Note aggiuntive sull'esame
 * @property {boolean} done - Stato dell'esame (completato o meno)
 */

/**
 * @typedef {Object} Exam
 * @property {number} id - ID del record dell'esame
 * @property {string} type - Tipo di esame
 */

/**
 * Servizio per gestire le informazioni dei cavalli.
 */
class HorsesExamService {

    abortController = null;

    constructor() {
        this.axiosInstance = axiosService.getInstance(); // Usa l'istanza di AxiosService
    }

    

    /**
     * 
     * @returns {Promise<HorseExam[]>} - 
     * @throws {Error} - 
     */
    async getHorseExams(page, search = '', params = {}, length = 10) {
        try {
            const response = await this.axiosInstance.post('horse-exams/get-exams-given-horse-id', {page, length, search, ...params});

            if (response.status !== 200) {
                throw new Error('Failed to fetch horse exams info');
            }

            /** @type {HorseExam[]} */
            return response.data;
        } catch (error) {
            console.error('Error fetching horse exams info:', error);
            throw error; // Rialza l'errore per gestirlo nel chiamante
        }
    }

    /**
     * 
     * @returns {Promise<HorseExam>} - 
     * @throws {Error} - 
     */
    async getHorseExamById(id) {
        try {
            const response = await this.axiosInstance.post('/horse-exams/get-horse-exam-given-id', {horse_exam_id: id});

            if (response.status !== 200) {
                throw new Error('Failed to fetch horse exam info');
            }

            /** @type {HorseExam} */
            return response.data.data;
        } catch (error) {
            console.error('Error fetching horse exam info:', error);
            throw error; // Rialza l'errore per gestirlo nel chiamante
        }
    }


    /**
     * 
     * @returns {Promise<HorseExam>} 
     * @throws {Error} 
     */
    async saveHorseExam(data) {
        try {
            const formData = new FormData();

            // Separate File objects from horse_images and keep only those with id
            const files = [];
            const imagesWithId = data.horse_exam_images.filter(image => {
                if (image.url instanceof File) {
                    files.push(image.url);
                    image.url = null;
                    return false; // Exclude this item from horse_images
                }
                return true; // Keep this item in horse_images
            });

            console.log(imagesWithId);

            // Append all fields in data to FormData individually
            for (const key in data) {
                if (key === 'horse_exam_images') {
                // Append the modified horse_images to FormData as a JSON string
                formData.append('horse_exam_images', JSON.stringify(data.horse_exam_images));
                } else {
                // Append other fields as they are
                formData.append(key, data[key]);
                }
            }

            // Append each File object to FormData under the 'files' field
            files.forEach((file, index) => {
                formData.append(`files[${index}]`, file);
            });
            const response = await this.axiosInstance.post('/horse-exams/save-horse-exam', formData, {
                headers: {
                  'Content-Type': 'multipart/form-data',
                },
              });

            if (response.status !== 200) {
                throw new Error('Failed to save horse exam data');
            }

            /** @type {HorseExam} */
            return response.data.data.result;
        } catch (error) {
            console.error('Error saving horse exam:', error);
            throw error; // Rialza l'errore per gestirlo nel chiamante
        }
    }

    /**
     * 
     * @returns {Promise<Exam[]>}
     * @throws {Error}
     */
    async getExams() {
        try {
            const response = await this.axiosInstance.post('/horse-exams/get-exams');

            if (response.status !== 200) {
                throw new Error('Failed to fetch exams info');
            }

            /** @type {Exam[]} */
            return response.data.data.exams;
        } catch (error) {
            console.error('Error fetching exams info:', error);
            throw error; // Rialza l'errore per gestirlo nel chiamante
        }
    }

    
}

export const horsesExamService = new HorsesExamService();
